module.exports = __webpack_public_path__ + "img/b-school.a26f2af3.png";